import styled from "styled-components";

export default styled.div`
    flex-direction: column;
    display: flex;
    flex-grow: 1;
`;
